/* global google */
import React, { useState, useEffect, useCallback } from 'react';
import { AdvancedMarker, APIProvider, Map, useMapsLibrary, Marker, Pin, useMap, InfoWindow } from '@vis.gl/react-google-maps';
import markericonOver from "assets/img/maps/over.png";
import moment from "moment";
//import OverlappingMarkerSpiderfier from "overlapping-marker-spiderfier";
import "../style.css";

const mapstyle = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#38414e" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#212a37" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#746855" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#1f2835" }],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit.station",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#17263c" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#515c6d" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: 'off' }]
    },
];

export default function MapComponent(props) {
    const { markersraw, onMarkerClickCallback, activeSiteId, overSiteId, selectedOption } = props;

    const [markers, setMarkers] = useState();
    const [bounds, setBounds] = useState();

    const map = useMap();

    useEffect(() => {
        reBuildMarkers(activeSiteId, overSiteId);
    }, [activeSiteId, overSiteId])


    const [infowindowData, setInfowindowData] = useState(null);

    const handleInfoWindowClose = useCallback(
        () => setInfowindowData(null),
        [setInfowindowData]
    );

    useEffect(() => {
        if (!map)
            return;
        var styledMapType = new google.maps.StyledMapType(mapstyle,
            { name: "Simple" });
        map.mapTypes.set("styled_map", styledMapType);
        map.setMapTypeId("styled_map");

        var boundsTmp = new google.maps.LatLngBounds();
        var markersTmp = [];
        if (markersraw.length == 0) {
            boundsTmp.extend(new google.maps.LatLng(50.1, 2.4));
            boundsTmp.extend(new google.maps.LatLng(42.7, 2.4));
        }
        markersraw.map((mark, i) => {
            boundsTmp.extend(new google.maps.LatLng(mark.destination.location.lat, mark.destination.location.lng));
            var marker = buildMarker(mark.option, mark.destination, null, null);
            markersTmp.push(marker);
        })
        map.fitBounds(boundsTmp);
        setMarkers(markersTmp);
        setBounds(boundsTmp);

        // const oms = new OverlappingMarkerSpiderfier(map);
        // markers.forEach((m) => oms.addMarker(m));

    }, [markersraw, map])


    const buildMarker = (option, destination, activeSiteId, overSiteId) => {
        var marker;
        var animationtodisplay = 0;
        var labeltodisplay = '';
        var icontodisplay = option.unselectedicon;
        var zindex = 0;

        if (overSiteId == destination.id) {
            animationtodisplay = google.maps.Animation.BOUNCE;
            icontodisplay = markericonOver;
        }
        if (activeSiteId == destination.id) {
            icontodisplay = option.selectedicon;
            zindex = 9999;
        }
        marker = <Marker
            key={destination.id}
            position={destination.location}
            onClick={(event) => onMarkerClick(destination)}
            name={destination.text}
            site={destination}
            title={destination.text}
            clickable={true}
            icon={icontodisplay}
            animation={animationtodisplay}
            zIndex={zindex}
        >

        </Marker>
        return marker;
    };



    const onMarkerClick = (destination) => {
        onMarkerClickCallback(destination);
    };

    const reBuildMarkers = (activeSiteId, overSiteId) => {
        var markersTmp = [];
        markersraw.map((mark, i) => {
            var marker = buildMarker(mark.option, mark.destination, activeSiteId, overSiteId);
            markersTmp.push(marker);
        })
        setMarkers(markersTmp);
    };

    const mapTypeControlOptions = {
        mapTypeIds: [
            "styled_map",
            "satellite",
        ]
    };
    return (
        <Map
            mapTypeControlOptions={mapTypeControlOptions}
            defaultCenter={{ lat: 46.778476, lng: 2.392557 }}
            defaultZoom={10}
            mapId='888-777-666'
            className={'custom-marker-clustering-map'}

        >
            {markers}
        </Map>


    );
}

